// src/data/messagesData.js

import { format, subDays, subHours, subMinutes } from "date-fns";

/**
 * A list of sample conversations including clients, prospects,
 * group chats with colleagues and industry peers.
 */
export const conversations = [
    {
        id: 1,
        type: "client",
        name: "Greg Paulman",
        company: "Digiset Capital Services, Inc.",
        lastMessage: "Thanks for the update, talk soon!",
        time: format(subHours(new Date(), 2), "p"), // 2 hours ago
        unread: true,
        starred: false,
        messages: [
            {
                from: "system",
                content: format(new Date(), "MMMM d, yyyy p"),
            },
            {
                from: "Greg Paulman",
                content: "Thanks for sending the quarterly report.",
            },
            {
                from: "you",
                content: "You're welcome! Let me know if you have any questions.",
            },
            {
                from: "Greg Paulman",
                content: "Will do. Talk soon!",
            },
        ],
    },
    {
        id: 2,
        type: "prospect",
        name: "Linda Soto",
        company: "",
        lastMessage: "Could we meet next week?",
        time: format(subDays(new Date(), 1), "MMM d, yyyy p"), // yesterday
        unread: false,
        starred: true,
        messages: [
            {
                from: "system",
                content: format(subDays(new Date(), 1), "MMMM d, yyyy p"),
            },
            {
                from: "Linda Soto",
                content: "Hi—I saw your article on retirement planning. Could we meet next week?",
            },
            {
                from: "you",
                content: "Absolutely, how does Tuesday at 2 PM look for you?",
            },
            {
                from: "Linda Soto",
                content: "That works great, thank you!",
            },
        ],
    },
    {
        id: 3,
        isGroup: true,
        title: "Tax Prep Team",
        participants: ["You", "Janet Miller", "Raj Patel"],
        lastMessage: "Raj: I've uploaded the client docs.",
        time: format(subDays(new Date(), 1), "p"), // yesterday
        unread: false,
        starred: false,
        messages: [
            {
                from: "system",
                content: format(subDays(new Date(), 1), "MMMM d, yyyy p"),
            },
            {
                from: "Janet Miller",
                content: "Reminder: Client calls start at 9 AM tomorrow.",
            },
            {
                from: "you",
                content: "Got it—I'll be ready.",
            },
            {
                from: "Raj Patel",
                content: "I've uploaded the client docs to the shared folder.",
            },
        ],
    },
    {
        id: 4,
        isGroup: true,
        title: "Tech Investing Forum",
        participants: ["You", "Bobby Chen", "Alex Rivera"],
        lastMessage: "Alex: Next webinar is Tuesday.",
        time: format(subDays(new Date(), 2), "MMM d, yyyy p"), // two days ago
        unread: false,
        starred: false,
        messages: [
            {
                from: "system",
                content: format(subDays(new Date(), 2), "MMMM d, yyyy p"),
            },
            {
                from: "Bobby Chen",
                content: "Did anyone catch the earnings call this morning?",
            },
            {
                from: "Alex Rivera",
                content: "Yes—I'll share my notes in a bit.",
            },
            {
                from: "you",
                content: "Thanks, looking forward to it.",
            },
        ],
    },
    {
        id: 5,
        type: "prospect",
        name: "Michael Rios",
        company: "",
        lastMessage: "I'm interested in your services.",
        time: format(subDays(new Date(), 2), "p"), // two days ago
        unread: false,
        starred: false,
        messages: [
            {
                from: "system",
                content: format(subDays(new Date(), 2), "MMMM d, yyyy p"),
            },
            {
                from: "Michael Rios",
                content: "Hello, I’m interested in your wealth management services.",
            },
            {
                from: "you",
                content: "Great! Let’s schedule a discovery call—what works for you?",
            },
        ],
    },
    {
        id: 6,
        type: "client",
        name: "Sarah Blake",
        company: "WealthPlan Advisors",
        lastMessage: "Please review my portfolio.",
        time: format(subHours(subDays(new Date(), 1), 3), "p"), // yesterday minus 3 hours
        unread: false,
        starred: false,
        messages: [
            {
                from: "system",
                content: format(subDays(new Date(), 1), "MMMM d, yyyy p"),
            },
            {
                from: "Sarah Blake",
                content: "Can you please review my portfolio allocations?",
            },
            {
                from: "you",
                content: "Of course—I'll send my analysis by end of day.",
            },
            {
                from: "Sarah Blake",
                content: "Thanks!",
            },
        ],
    },
    {
        id: 7,
        isGroup: true,
        title: "Compliance Update",
        participants: ["You", "Regulatory Team", "Legal Dept."],
        lastMessage: "Legal Dept.: Deadline is Friday.",
        time: format(subDays(new Date(), 3), "p"), // three days ago
        unread: false,
        starred: false,
        messages: [
            {
                from: "system",
                content: format(subDays(new Date(), 3), "MMMM d, yyyy p"),
            },
            {
                from: "Regulatory Team",
                content: "New SEC guidelines released today.",
            },
            {
                from: "Legal Dept.",
                content: "Deadline for compliance docs is Friday.",
            },
        ],
    },
];

/**
 * A list of channel topics that can be toggled on/off. 
 * Some are locked (e.g. premium or internal).
 */
export const channels = [
    { id: 1, name: "Market Trends", locked: false },
    { id: 2, name: "Regulatory Updates", locked: true },
    { id: 3, name: "Tech Investing", locked: false },
    { id: 4, name: "Client Alerts", locked: false },
    { id: 5, name: "Internal Announcements", locked: true },
];

export const currentUser = {
    joinedDate: format(subDays(new Date(), 7), "MMMM d, yyyy p"),
};
